import { render, staticRenderFns } from "./upload-document-button.vue?vue&type=template&id=0c815e1c"
import script from "./upload-document-button.vue?vue&type=script&lang=js"
export * from "./upload-document-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports